
export default (setPools: Function) => (poolId: string, name: string, color: string) => {
  
  return setPools((ps: any) => ps.map((item: any) => ({
    ...item,
    name: poolId === item._id ? name : item.name,
    color: poolId === item._id ? color : item.color,
  })));
}